import {ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output,} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';
import {AuthService} from "../../../shared/services/auth.service";

export interface MenuItem {
    title: string;
    link?: string;
    queryParams?: any;
    evaIcon?: string;
    materialIcon?: string;
    submenu?: { title: string, link: string, queryParams?: any }[];
    expanded?: boolean;
}

@Component({
    selector: 'app-sidenav',
    templateUrl: './sidenav.component.html',
    styleUrls: ['./sidenav.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SidenavComponent implements OnInit {
    @Output() menuToggle: EventEmitter<void> = new EventEmitter<void>();
    @Input() showClose = false;

    activeLink: string;

    menuItems: MenuItem[] = [];


    constructor(private router: Router, private authService: AuthService, private cdr: ChangeDetectorRef) {
    }

    ngOnInit() {
        this.urlChanged(this.router.url);

        if(this.authService.userCan('dashboard:view')) {
            this.menuItems.push({
                title: 'Acasă',
                link: '/admin/dashboard',
                evaIcon: 'grid-outline',
                queryParams: {days: '1'}
            });
        }
        if(this.authService.userCan('bookings:view')) {
            this.menuItems.push({
                title: 'Curse',
                link: '/admin/bookings',
                evaIcon: 'book-outline',
            });
        }
        if(this.authService.userCan('drivers:view')) {
            this.menuItems.push({
                title: 'Șoferi',
                link: '/admin/drivers',
                evaIcon: 'car-outline',
            });
        }
        if(this.authService.userCan('riders:view')) {
            this.menuItems.push({
                title: 'Clienti',
                link: '/admin/riders',
                evaIcon: 'person-outline',
            });
        }
        if(this.authService.userCan('operators:view')) {
            this.menuItems.push({
                title: 'Operatori',
                link: '/admin/operators',
                evaIcon: 'umbrella-outline',
            });
        }
        if(this.authService.userCan('dispatches:view')) {
            this.menuItems.push({
                title: 'Dispecerate',
                link: '/admin/dispatches',
                evaIcon: 'umbrella',
            });
        }
        if(this.authService.userCan('invoices:view')) {
            this.menuItems.push({
                title: 'Facturi',
                link: '/admin/invoices',
                evaIcon: 'credit-card',
            });
        }
        if(this.authService.userCan('settings:view')) {
            this.menuItems.push({
                title: 'Configurări',
                link: '/admin/settings',
                evaIcon: 'settings-2-outline',
            });
        }
        if(this.authService.userCan('request-access:view')) {
            this.menuItems.push({
                title: 'Cereri de acces',
                evaIcon: 'flag-outline',
                submenu: [
                    {
                        title: 'Șoferi / Operatori',
                        link: '/admin/request-access',
                        queryParams: {status: 'new,inProgress', type: 'driver,operator,websiteDriver'},
                    },
                    {
                        title: 'Clienti',
                        link: '/admin/request-access',
                        queryParams: {status: 'new,inProgress', type: 'websiteRider'},
                    }
                ]
            });
        }
        if(this.authService.userCan('reviews:view')) {
            this.menuItems.push({
                title: 'Recenzii',
                link: '/admin/reviews',
                evaIcon: 'star-outline'
            });
        }
        if(this.authService.userCan('promos:view')) {
            this.menuItems.push({
                title: 'Coduri Promo',
                evaIcon: 'gift-outline',
                submenu: [
                    {
                        title: 'Promotii',
                        link: '/admin/promo-codes',
                        queryParams: {type: 'promotion'}
                    },
                    {
                        title: 'Invitatii',
                        link: '/admin/promo-codes',
                        queryParams: {type: 'referral'}
                    },
                    {
                        title: 'Recompense',
                        link: '/admin/promo-codes',
                        queryParams: {type: 'referralBack'}
                    }
                ]
            });
        }
        if(this.authService.userCan('admins:view')) {
            this.menuItems.push({
                title: 'Administratori',
                link: '/admin/admins',
                evaIcon: 'headphones-outline',
            });
        }
        if(this.authService.userCan('pushNotificationTopic')) {
            this.menuItems.push({
                title: 'Notificari Push',
                link: '/admin/push-notification',
                evaIcon: 'bell-outline',
            });
        }
        // Dropdown-ul "Termeni & altele" (Termeni soferi / Termeni client / Privacy client)
        // a fost ascuns din decizie internă. Termenii și condițiile sunt acum disponibili
        // direct pe boost.taxi și sofer.boost.taxi. Lăsat comentat în caz că trebuie reactivat.
        // if(this.authService.userCan('terms:view')) {
        //     this.menuItems.push({
        //         title: 'Termeni & altele',
        //         evaIcon: 'book-outline',
        //         submenu: [
        //             {
        //                 title: 'Termeni soferi',
        //                 link: '/admin/terms-edit',
        //                 queryParams: {type: 'driverTerms'}
        //             },
        //             {
        //                 title: 'Termeni client',
        //                 link: '/admin/terms-edit',
        //                 queryParams: {type: 'riderTerms'}
        //             },
        //             {
        //                 title: 'Privacy client',
        //                 link: '/admin/terms-edit',
        //                 queryParams: {type: 'riderPrivacy'}
        //             }
        //         ]
        //     });
        // }
        if(this.authService.userCan('overview:view')) {
            this.menuItems.push({
                title: 'Hartă',
                link: '/admin/overview',
                evaIcon: 'map-outline',
            });
        }
        if(this.authService.userCan('logs:socket')) {
            this.menuItems.push({
                title: 'Logs Socket (debug)',
                link: '/admin/logs-socket',
                evaIcon: 'activity-outline',
            });
        }

        this.cdr.detectChanges();

        // {
        //     title: 'Șoferi de plătit',
        //         link: '/admin/drivers-to-pay',
        //     evaIcon: 'credit-card-outline',
        //     queryParams: {type: '3daysBefore'}
        // },

    }

    urlChanged(url) {
        this.activeLink = url.split('?')[0];
        this.setExpanded();
        this.cdr.detectChanges();
    }

    setExpanded() {
        this.menuItems.filter(item => item.submenu != null).forEach(item => {
            item.expanded = item.submenu.map(i => i.link).includes(this.activeLink);
        });
    }

}
